// src/Components/modules/Dialog/respuestasCierre.js
export const respuestasCierre = {
  Cancelado: [
    "CANCELADO USUARIO SE TRASLADA POR SUS MEDIOS",
    "CANCELADO POR INCUMPLIMIENTO DE LA MÓVIL",
    "CANCELADO SIN ASIGNACIÓN DE MÓVIL POR PARTE DE COORDINACIÓN",
    "CANCELADO - MANEJO INTERNO NO AUTORIZADO",
    "CANCELADO POR HOSPITALIZACIÓN / CANCELADO POR ENFERMEDAD",
    "AUSENCIA DE ACOMPAÑANTE",
    "CANCELACIÓN DE CITA MÉDICA / IPS NO PRESTA SERVICIO / SIN AUTORIZACIÓN DE EPS",
    "CANCELADO USUARIO FALLECIDO",
    "CANCELADO POR DISPONIBILIDAD",
    "CANCELADO, USUARIO NO ASISTE POR MOTIVOS PERSONALES",
    "CANCELADO OPERADOR HACE PRESENCIA SIN EVIDENCIAS DEL FALLIDO",
    "CANCELADO USUARIO NO ASISTE, CUMPLE OTRAS CITAS O EXÁMENES MÉDICOS",
    "CANCELADO, NO SE LOGRA CONTACTO CON USUARIO, NI EN DOMICILIO NI POR LLAMADA // USUARIO FUERA DE LA CIUDAD",
    "CANCELADO, REPROGRAMACIÓN DE CITAS",
    "CANCELADO POR INCONFORMIDAD CON LA PROGRAMACIÓN DEL SERVICIO /PROGRAMACIÓN ERRADA",
    "CANCELADO, FALTA DE CONFIRMACIÓN POR PARTE DEL OPERADOR O CALL CENTER",
    "CANCELADO OPERADOR / USUARIO CON MALA DISPOSICIÓN PARA PRESTAR EL SERVICIO",
    "GPS NO COINCIDE RECORRIDO / TIEMPOS CON SERVICIO ASIGNADO EN PLATAFORMA",
    "CANCELADO (DERRUMBE, ACCIDENTE, BLOQUEOS, MÓVIL VARADA, ORDEN PÚBLICO, FACTORES CLIMÁTICOS - VÍALES)",
    "CANCELADO, FALLAS TECNOLÓGICAS EN PLATAFORMA - SERVIDORES (SERV. SIN PROGRAMAR)",
    "CANCELADO, ORIGEN - DESTINO DIFERENTES A LOS AUTORIZADOS",
    "CANCELADO, INCONFORMIDAD CON TIPOLOGÍA DE LA MÓVIL",
    "CANCELADO, SERVICIO ASIGNADO A OTRA TRANSPORTADORA",
    "CANCELADO, USUARIO CON MÁS DE UN ACOMPAÑANTE",
    "CANCELADO, SIN CONTACTO CON USUARIO, NI EN DOMICILIO NI POR LLAMADA // USUARIO FUERA DE LA CIUDAD",
    "CANCELADO POR DUPLICIDAD",
    "CANCELADO POR SERVICIO COMPARTIDO CON UNO O MÁS USUARIOS",
    "CANCELADO POR MEJORIA EN SU ESTADO DE SALUD / DESESTIMIENTO EN SU TRATAMIENTO",
    "CANCELADO POR NOVEDAD EN EL PRIMER TRASLADO"
  ],
  Fallido: [
    "FALLIDO, NO SE LOGRA CONTACTO CON USUARIO, NI EN DOMICILIO NI POR LLAMADA // USUARIO FUERA DE LA CIUDAD",
    "FALLIDO, USUARIO NO TOMA SERVICIO NO ALCANZA LLEGAR A LA CITA",
    "FALLIDO POR NOVEDAD EN EL TRAYECTO (DERRUMBE, ACCIDENTE, BLOQUEOS, MÓVIL VARADA)",
    "FALLIDO, USUARIO FALLECIDO",
    "FALLIDO, NO ASISTE / RAZONES PERSONALES / O CITAS MÉDICAS ADICIONALES",
    "FALLIDO, CANCELACIÓN-REPROGRAMACIÓN DE CITA MÉDICA / IPS NO PRESTA SERVICIO / SIN AUTORIZACIÓN DE EPS",
    "FALLIDO, ORIGEN - DESTINO DIFERENTES A LOS AUTORIZADOS",
    "FALLIDO, USUARIO HOSPITALIZADO / USUARIO INDISPUESTO",
    "FALLIDO, INFORMACIÓN (HORARIOS , DATOS GEOGRÁFICOS) INCORRECTOS EN PLATAFORMA",
    "FALLIDO, SE TRASLADA POR SUS MEDIOS / O SALE ANTES DE LA HORA",
    "FALLIDO, USUARIO TARDA EN SALIR DE LA UNIDAD MÉDICA Y/O DOMICILIO",
    "FALLIDO, USUARIO NO CUENTA CON ACOMPAÑANTE",
    "FALLIDO, OPERADOR / USUARIO CON MALA DISPOSICIÓN PARA PRESTAR EL SERVICIO",
    "FALLIDO EPS REALIZÓ MAL LA AUTORIZACIÓN YA QUE ERA PARA 2 DÍAS Y SOLO AUTORIZÓ UNO",
    "FALLIDO, USUARIO TRASLADADO A UNIDAD ASISTENCIAL POR URGENCIAS",
    "FALLIDO, USUARIO NO TENÍA SERVICIO PARA EL DÍA DE HOY",
    "FALLIDO, TRASLADO PRESTADO POR OTRA TRANSPORTADORA",
    "FALLIDO, NO TOMA SERVICIO COMPARTIDO",
    "FALLIDO, TRASLADO REALIZADO POR OTRA MÓVIL",
    "FALLIDO, USUARIO CON MÁS DE UN ACOMPAÑANTE"
  ],
  Finalizado: [
    "SERVICIO SIN NOVEDAD",
    "SERVICIO CON ATRASO",
    "SERVICIO COMPARTIDO CON 1 O MÁS USUARIOS",
    "SERVICIO CON EXCESO DE VELOCIDAD",
    "SERVICIO NO SE REALIZA, PLANILLA QUEDA REDONDA",
    "SERVICIO PARA REVISION DE NOVEDAD STATUS SIN DEFINIR",
    "SERVICIO MANEJO INTERNO",
    "INCONFORMIDAD CON TIPOLOGIA DE VEHÍCULO USUARIO",
    "RECOGIDA REALIZADA CON PÉRDIDA DE CITA",
    "OPERADOR / USUARIO CON MALA DISPOSICIÓN PARA PRESTAR EL SERVICIO",
    "TRASLADO EN VEHÍCULO TIPO TAXI O PARTICULAR",
    "USUARIO DESCOMPENSADO",
    "REASIGNACIÓN DE MÓVIL / FALLAS MECÁNICAS / MÓVIL ACCIDENTADA / CAMBIO DE MÓVIL",
    "TRASLADADO SIN ACOMPAÑANTE USUARIO CON DISCAPACIDAD",
    "USUARIO SOLICITA CAMBIO DE HORARIO CON EL OPERADOR",
    "USUARIO CON RETRASO POR INCONVENIENTES EN EL CENTRO MÉDICO",
    "SE TRASLADA CON MÓVIL DE OTRA EMPRESA DE SERVICIO ESPECIAL",
    "SERVICIO SUJETO A DISPONIBILIDAD",
    "OPERADOR CAMBIA HORARIOS DE SERVICIO",
    "OPERADOR NO CUMPLE CON EL RECORRIDO HASTA EL DESTINO",
    "USUARIO RECOGIDO - DEJADO EN LUGAR DIFERENTE POR INCONVENIENTES EN LA ZONA",
    "USUARIO SE TRASLADA CON MÁS DE UNA ACOMPAÑANTE",
    "SERVICIO EFECTIVO - VACÍO DE LA MÓVIL",
    "USUARIO FALLECIDO PLANILLA QUEDA REDONDA",
    "SERVICIO CON PROGRAMACIÓN DIFERENTE vs PLATAFORMA",
    "USUARIO EN EL TRAYECTO SE DESCOMPENSA POR LO QUE SE TRASLADA A URGENCIAS",
    "USUARIO MOLESTO YA QUE EL OPERADOR TOMA RUTAS ALTERNAS POR NO PAGO DE PEAJES LO QUE AFECTA SU ESTADO DE SALUD"
  ]
};
